import { Icon, ToolTip, useTranslation } from '@testsigma/atoms';
import classNames from 'classnames';

interface BrowserDeviceTypeProps {
  browserName: string;
  browserVersion: string;
  className?: string;
  variant?: 'detail' | 'concise';
  tooltipPlacement?: any;
  isHeadLess?: boolean;
}

const browserIconMapping = {
  CHROME: 'chrome',
  GOOGLECHROME: 'chrome',
  FIREFOX: 'firefox',
  MOZILLAFIREFOX: 'firefox',
  SAFARI: 'safari',
  EDGE: 'edge',
  MICROSOFTEDGE: 'edge',
  INTERNETEXPLORER: 'internet-explorer',
  GOOGLECHROMEFORTESTING: 'chrome',
  CHROMEFORTESTING: 'chrome',
};

export const BrowserDeviceType: React.FC<BrowserDeviceTypeProps> = ({
  browserName,
  browserVersion,
  className,
  variant = 'concise',
  tooltipPlacement,
  isHeadLess,
}) => {
  const { t } = useTranslation();
  browserName = browserName?.toUpperCase() || 'unknown';
  browserVersion = browserVersion
    ? 'V.' + browserVersion
    : t('browser.short-name.' + browserName);

  if (!browserName || !browserVersion) return <></>;
  return (
    <ToolTip
      placement={tooltipPlacement}
      content={
        browserName === 'unknown'
          ? ''
          : t('browser.name.' + browserName) +
            ` ${browserVersion}` +
            (isHeadLess ? ` (${t('headless_test.label')})` : '')
      }
      align='center'
    >
      <span className={classNames('flex flex-row items-center', className)}>
        <Icon
          name={browserIconMapping[browserName]}
          className='text-secondary-400 group-hover:text-secondary-unique-800 hover:text-secondary-unique-800 text-md'
        />
        {variant === 'detail' && (
          <span className='ml-2 truncate'>{browserVersion}</span>
        )}
      </span>
    </ToolTip>
  );
};
